module.exports = __webpack_public_path__ + "img/giftcert-creation-page.f9550b6.png";